import React from 'react';
import './style.css';
import { Button } from '@vwfs-bronson/bronson-react';
import { setBifrostAuthConfig, setEmobgAuthConfig } from "../../utils/auth-utils";
import bifrostLogo from '../../images/bifrost.png'
import emobgLogo from '../../images/emobg.png'
import AppWrapper from '../../components/base/app-wrapper';
import { useAppSelector } from '../../redux/hooks';
import { selectNotificationStore } from '../../redux/slices/notification-slice';


export default function LoginViewPage() {
  const notification = useAppSelector(selectNotificationStore());

  const handleEmobgLogin = () => {
    setEmobgAuthConfig();
    window.location.reload();
  }

  const handleBifrostLogin = () => {
    setBifrostAuthConfig();
    window.location.reload();
  }

  return (
    <AppWrapper
      errorDialog={notification?.errorDialog}>
      <div className="login-container" data-testid="login-container">
        <div className='row1col2' data-testid="bifrost-logo"><img src={bifrostLogo} className="login-logo" onClick={handleBifrostLogin} /></div>
        <div className='row1col4' data-testid="emobg-logo"><img src={emobgLogo} className="login-logo" onClick={handleEmobgLogin} /></div>
        <div className='row2col2' data-testid="bifrost-button">
          <Button
            className='blue-button'
            data-testid='loginEmobg'
            onClick={handleBifrostLogin}
            title='Bifrost'
            icon='semantic-login'
          >
            Login with Bifrost
          </Button>
        </div>
        <div className='row2col4' data-testid="emobg-button">
          <Button
            className='blue-button'
            data-testid='loginEmobg'
            onClick={handleEmobgLogin}
            title='Emobg'
            icon='semantic-login'
          >
            Login with EMG
          </Button>
        </div>
      </div>
    </AppWrapper>
  );
}
